import "./NotificationsListSkeleton.scss";

export const NotificationsListSkeleton = () => {
  return (
    <div className="docs-skeleton-container">
      {/* Search and filters row */}
      <div className="docs-skeleton-search-row">
        <div className="docs-skeleton-search-input pulse"></div>
        <div className="docs-skeleton-search-button pulse"></div>
        <div className="docs-skeleton-filter-button pulse"></div>
      </div>

      {/* Tabs with actions */}
      <div className="docs-skeleton-tabs-row">
        <div className="docs-skeleton-tabs">
          <div className="docs-skeleton-tab-active pulse"></div>
          <div className="docs-skeleton-tab pulse"></div>
        </div>
        <div className="docs-skeleton-actions">
          <div className="docs-skeleton-action-button pulse"></div>
          <div className="docs-skeleton-action-button pulse"></div>
        </div>
      </div>

      {/* Document count */}
      <div className="docs-skeleton-count pulse"></div>

      {/* Year header */}
      <div className="docs-skeleton-year pulse"></div>

      {/* Row 1 */}
      <div className="docs-skeleton-row">
        {/* Document 1 */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>

        {/* Document 2 */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Horizontal divider */}
      <div className="docs-skeleton-divider"></div>

      {/* Row 2 */}
      <div className="docs-skeleton-row">
        {/* Document 3 */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>

        {/* Document 4 */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Horizontal divider */}
      <div className="docs-skeleton-divider"></div>

      {/* Row 3 */}
      <div className="docs-skeleton-row">
        {/* Document 5 */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>

        {/* Document 6 */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
